/**
 * Generated by orval v7.8.0 🍺
 * Do not edit manually.
 * TopTopTime API
 * <:3 )~~~~    =^.^=
 * OpenAPI spec version: 0.0.1
 */

/**
 * Kind of a bookable location: a fixed `venue` address, an `at_home` service area (base point + travel radius), or an `online` meeting room.
 */
export enum ActivityLocationKind {
  venue = 'venue',
  at_home = 'at_home',
  online = 'online'
}
